import {Environment} from '../../environment/environment';
import {TvshopConstants} from '../../tvshop-constants';
import {OmapiIdConstants} from '../../omapi-id-constants';
import {LabelConstants} from '../../label-constants';
import {ImageUtils} from '../image/image-utils';
import {OmapiIdsUtils} from '../omapi-ids/omapi-ids-utils';


export class TrialUtils {
  static getTrialOmapiIdForTrialLabel(label: string): string {
    return LabelConstants.LABEL_TRIAL_MAP.get(label);
  }

  static getLogoUrlForTrialOmapiId(trialOmapiId: string): string {
    return trialOmapiId ? Environment.environmentConfig().baseUrl + TvshopConstants.IMAGES_AEM_PATH +
      OmapiIdsUtils.getCorrectIdForResource(TrialUtils.getPackOmapiIdForTrial(trialOmapiId)) + '-logo.png' : '';
  }

  static getLogoUrlForOmapiId(omapiId: string): string {
    return ImageUtils.getLogoUrlForOmapiId(omapiId);
  }

  private static getPackOmapiIdForTrial(trialOmapiId: string): string {
    return OmapiIdConstants.PRODUCT_TRIAL_MAP.get(trialOmapiId);
  }
}
